import React, { useMemo } from 'react';
import {
  useAppDispatch,
  useAppSelector,
  useTranslate,
  useWidgetParam,
  useWidgetsTheme as theme,
} from '../../core/hooks';
import {
  goToNextStep,
  productAdderStepState,
  isCurrentStepValid,
  currentProductAdderStatus,
  productSelector,
} from '../../features/product';
import { useWidgetId } from '../../core/IdProvider';
import { GradientButton } from '../reusable';
import { track } from '@src/services/analytics';
import useSelectedProductId from '@src/hooks/useSelectedProductId';

const ProductAdderNextStepButton = () => {
  const widgetId = useWidgetId();
  const status = useAppSelector(currentProductAdderStatus(widgetId));
  const cartAddCtaText = useWidgetParam('cart-add-cta-text');
  const stepIsValid = useAppSelector(isCurrentStepValid(widgetId));
  const { isAtLast } = useAppSelector(productAdderStepState(widgetId));
  const dispatch = useAppDispatch();
  const actionColor = theme('actionColor');
  const { i18n } = useTranslate();
  const productId = useSelectedProductId();
  const product = useAppSelector(productSelector(productId))!;

  const handleGoForwards = () => {
    if (!isAtLast) {
      track('productAdderNextStep', {
        productId: productId,
        productName: product.name,
      });
    }

    dispatch(goToNextStep(widgetId));
  };

  const getCtaText = () => (cartAddCtaText ? cartAddCtaText : i18n('adder_purchaseButton'));

  const disabled = useMemo(() => !stepIsValid || status === 'adding_to_cart', [stepIsValid, status]);

  return (
    <GradientButton
      disabled={disabled}
      actionColor={actionColor}
      onClick={handleGoForwards}
      dataCy='productAdderNextStepButton'
    >
      {isAtLast ? getCtaText() : i18n('adder_goForwardsFooter')}
    </GradientButton>
  );
};

export default ProductAdderNextStepButton;
